import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { BlockTitleDate1Link0 } from '../../Components/Public/Blocks/BlockTitleDate1Link0.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const Outlinks = (props) => {
    const { navParks } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [body, setBody] = useState([]);
    const [outlinks, setOutlinks] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasOutlinks = await fetch(`${backend}/outlinks`, GetHeaders(guest));
            const outlinks = await datasOutlinks.json();
            setOutlinks(outlinks);
            const bodyDatas = await fetch(`${backend}/outlinks/body`, GetHeaders(guest));
            const body = await bodyDatas.json();
            setBody(body);
        };
        fetchData();
        ScrollTop();
    }, [backend, guest]);
    const items = GetDescription('outlinks', { body: body, outlinks: outlinks });
    return (
        <div className="outlinks">
            <Navigation navParks={navParks} />
            <Header />
            <BreadCrumb label="outlinks" />
            <section className="infos">
                <div className="bloc-infos">
                    <div className="list">
                        {outlinks.map((el, i) => {
                            return (
                                <a key={`o-${i}`} href={el.route} alt={el.name} target="_blank" rel="noreferrer" className="link">
                                    <div className="code"><i className="fa fa-link"></i></div>
                                    <div className="name">{`${el.name}`}</div>
                                </a>
                            )
                        })}

                    </div>
                </div>
                <div className="description">
                    <BlockTitleDate1Link0 label="outlinks" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}